export const calculateExpiration = (
  expiredValue = new Date(),
  validityType,
  currentDate = new Date()
) => {
  // Parse `expiredValue` into a Date object
  const expirationDate = new Date(
    expiredValue.split("/").reverse().join("-") // Convert "DD/MM/YYYY" to "YYYY-MM-DD"
  );

  if (isNaN(expirationDate)) {
    throw new Error("Invalid expiration date format. Use 'DD/MM/YYYY'.");
  }

  currentDate = new Date(currentDate); // Ensure `currentDate` is a Date object

  // Calculate the difference in time (milliseconds)
  const timeDiff = expirationDate - currentDate;

  // Calculate remaining days
  const remainingDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  // Determine if the date has expired
  const isExpired = remainingDays < 0;

  // Return details along with the `validityType`
  return {
    expirationDate,
    remainingDays: isExpired ? 0 : remainingDays, // Set remainingDays to 0 if already expired
    isExpired,
    validityType, // Add validity type for context
    currentDate,
  };
};

export const CouponTypes = {
  Manual: "manual",
  Generated: "generated",
  Template: "template",
  Registration: "registration"
}

export const CouponTemplateTypes = [
  "template",
  "registration"
]
